// extracted by mini-css-extract-plugin
module.exports = {"namediv":"Home_namediv__33mFT","fa":"Home_fa__3tLzh","icon":"Home_icon__2A_k8"};